import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import * as XLSX from 'xlsx';
import { ActivityService } from '../../services/activity-services';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { config } from 'src/app/config/api.config';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-create-activity-invite',
  templateUrl: './create-activity-invite.component.html',
  styleUrls: ['./create-activity-invite.component.css'],
})
export class CreateActivityInviteComponent implements OnInit {
  sendMessageForm!: FormGroup;
  file: File | null = null;
  fileSize: number | null = null;
  fileName: string | null = null;
  fileContent: string[] | null = null;
  excelData: any[] | null = null;
  activities: any[] = [];
  isSubmitting: boolean = false;

  succes = false;
  error = false;
  formValidity = false;
  maxFileSize: number = 5120000;
  loading = true;
  url: string = config.openBaseUrl;
  id_Document = 'bfd8a828-ae2d-4db7-a85c-b25f67f9e478';
  fileIsValid: boolean = false;
  constructor(
    private fb: FormBuilder,
    private activityService: ActivityService,
    private spinnerService: SpinnerServiceService,
    private router: Router
  ) {
    this.sendMessageForm = this.fb.group({
      activity: [null, Validators.required],
      file: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.getActivities();
  }

  private getActivities(): void {
    this.spinnerService.showSpinner();
    this.activityService.getListActivities().subscribe({
      next: (activities) => {
        this.activities = activities;
        this.loading = false;
        this.spinnerService.hideSpinner();
      },
      error: () => {
        this.error = true;
        this.spinnerService.hideSpinner();
      },
    });
  }

  public onChangeBis(event: any): void {
    const file = event.target.files[0];
    // if (!file) {
    //   this.error = true;
    //   return;
    // }
    if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
      this.file = event.target.files[0];
      this.fileSize = file.size;
      this.fileName = file.name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        this.excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        this.validateExcelHeaders(this.excelData);
        this.fileContent = this.excelData
          ?.map((row) => row[0]?.toString())
          .filter((content) => content);
      };
      reader.readAsArrayBuffer(file);
    } else {
      alert('Veuillez télécharger un fichier Excel valide.');
    }
  }

  public onSubmitForm() {
    if (this.sendMessageForm.valid) {
      if (this.file) {
        this.isSubmitting = true;

        this.spinnerService.showSpinner();
        const activityId = this.sendMessageForm.get('activity')?.value;
        this.activityService
          .uploadInviteexcelFile(this.file, activityId)
          .pipe(
            tap((response: CustomResponse) => {
              if (response.status == 200) {
                this.isSubmitting = false;
                this.spinnerService.hideSpinner();
                this.succes = true;
                setTimeout(() => {
                  this.succes = false;
                  this.sendMessageForm.reset();
                  this.fileName = '';
                  this.isSubmitting = false;
                }, 5000);
              } else if (response.status == 400) {
                this.formValidity = true;
                setTimeout(() => {
                  this.formValidity = false;
                }, 3000);
              } else if (response.status == 401) {
                this.error = true;

                setTimeout(() => {
                  this.error = false;
                }, 3000);
              }
            })
          )
          .subscribe();
      }
    } else {
      this.formValidity = true;

      setTimeout(() => {
        this.formValidity = false;
      }, 2500);
    }
  }
  public onCancel() {
    this.sendMessageForm.reset();
    this.fileName = '';
  }

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'OUTILS' },
    { label: 'CMS', url: '/dashboard/cms' },
    {
      label: 'AJOUTER DES INVITÉS À UNE ACTIVITÉ',
      url: '/dashboard/agenda/create-activity-invite',
    },
  ];
  // Validation des entêtes pour les fichiers Excel
  validateExcelHeaders(excelData: any[]): void {
    const firstRow = excelData[0];
    this.validateHeaders(firstRow);
  }

  // Validation commune pour vérifier que les entêtes sont conformes
  validateHeaders(headers: any[]): void {
    let isValid = true;

    this.expectedHeaders.forEach((value, index) => {
      if (!headers.includes(value)) {
        isValid = false;
      }
    });

    if (isValid) {
      // console.log('Les entêtes sont correctes');
      this.fileIsValid = true;
      // Envoyer les données au back-end ou continuer le traitement
    } else {
      this.fileIsValid = false;
      alert(
        `Les entêtes ne sont pas conformes. Entêtes attendues: ${this.expectedHeaders.join(
          ', '
        )}`
      );
    }
  }
  expectedHeaders = ['Prenom', 'Nom', 'Email', 'Sexe'];
}
